import ClinicArrivalBoard from "./components/ClinicArrivalBoard";
import ClinicArrivalTasksDetailUnassignDialog from "./components/tasksTable/tasksDetailTable/ClinicArrivalTasksDetailUnassignDialog";

function HotelPlanningClinicArrivalPage() {
    return (
        <div className="box-border flex h-[calc(100dvh-9.5rem)] min-h-0 w-full max-w-full flex-col overflow-hidden px-3 md:px-4">
            <ClinicArrivalBoard />
            <ClinicArrivalTasksDetailUnassignDialog />
        </div>
    );
}

export default HotelPlanningClinicArrivalPage;
